module.exports = __webpack_public_path__ + "img/haider_ahmed_eli_lilly-min.f226a569.jpg";